import { Link } from "react-router-dom";

export default function ConsentLine({ dark = false, testid = "consent-line" }) {
  return (
    <p className={`text-xs leading-relaxed ${dark ? "text-revo-ice/50" : "text-navy/50"}`} data-testid={testid}>
      By submitting, you agree to be contacted about ChargeRevo and to our{" "}
      <Link to="/privacy" className={`underline transition-colors ${dark ? "hover:text-revo-green" : "hover:text-navy"}`}>
        Privacy Policy
      </Link>
      . We never sell your data.
    </p>
  );
}
